import "./CompanyNewsTabComponent.scss";
import template from "./CompanyNewsTabComponent.html";
import {IComponentOptions} from "angular";
import {CodeAndExchange, Securities} from "../../../instruments/types/CodeAndExchange";

export const CompanyNewsTab = "tfCompanyNewsTab";

export function companyNewsTab(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<"
        },
        controllerAs: "ctrl",
        controller: CompanyNewsComponentController
    };
}

export class CompanyNewsComponentController {

    public set security(security: CodeAndExchange | null) {
        if (security == null) {
            this.newsCodes = [];
            this.showWidget = false;
        } else {
            this.newsCodes = [security];
            this.showWidget = true;
        }
    }

    public newsCodes: Securities;
    public showWidget = false;
}
